import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BasePage } from "../base/base";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { Tag } from "./blog";
import { getPost, getBannerSrc } from "../api/api";
import parse, { domToReact } from "html-react-parser";
import { Link } from "react-router-dom";
import { Loading } from "./loading";
import "./post.css";

const Post = () => {
  const [post, setPost] = useState(null);
  const location = useLocation();
  const path = location.pathname;
  const slug = path.split("/").pop();

  useEffect(() => {
    getPost(slug).then((data) => {
      data.doc = postprocess(data.html);
      setPost(data);
    });
  }, []);
  useEffect(() => {
    if (post && window.location.hash) {
      const element = document.getElementById(
        window.location.hash.substring(1),
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [post, window.location.hash]);

  const postprocess = (html) => {
    return parse(html, {
      replace: (domNode) => {
        // if no name skip
        if (!domNode.name) {
          return domNode;
        }
        // wrap all images in Zoom component
        if (domNode.name === "img") {
          return (
            <Zoom>
              <img {...domNode.attribs} />
            </Zoom>
          );
        }
        // wrap content of all headings in links
        if (domNode.name.match(/h[1-6]/)) {
          return (
            <domNode.name {...domNode.attribs}>
              <Link to={"#" + domNode.attribs.id}>
                {domToReact(domNode.children)}
              </Link>
            </domNode.name>
          );
        }
      },
    });
  };

  return (
    <BasePage>
      {post ? (
        <div className="blog-post">
          <div className="post-header">
            <div className="post-meta">
              <span className="post-author">{post.author}</span>
              <span className="post-date">
                {new Date(post.date).toLocaleDateString("en-DE", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
            <img
              src={getBannerSrc(post.banner)}
              alt={post.title + " banner"}
              className="post-banner"
            />
            <h1 className="post-title">{post.title}</h1>
            <div className="post-tags">
              {post.tags.map((tag, index) => (
                <Tag key={index} tag={tag} />
              ))}
            </div>
          </div>
          <div className="post-content">{post.doc}</div>
        </div>
      ) : (
        <Loading />
      )}
    </BasePage>
  );
};

export { Post };
